'use strict';

import {contractModel} from "../../models/contractmodel.js";
import {DSSectionCtrl} from "./dssectionctrl.js";

export class DS43RecoveriesCtrl extends DSSectionCtrl
{
	additionalOptions = [];
	participants = [];
	constructor($scope, $filter, jsDataService, $mdDialog){
		super($scope, $filter, jsDataService, $mdDialog);
		this.dataConstruct();
	}
	
	dataConstruct(){
		this.item = new contractModel(this.jsDataService.get('item', {}), this.$filter, this.jsDataService);
		if(typeof(this.item.liability_for_enforced_recoveries_data) !== 'undefined' && this.item.liability_for_enforced_recoveries_data.length > 0){
			this.additionalOptions = this.item.liability_for_enforced_recoveries_data;
		}
		if(typeof(this.item.participants_acronym) !== 'undefined' && this.item.participants_acronym.length > 0){
			this.participants = this.item.participants_acronym;
		}
	}
	
	modelValue(name){
		if(typeof(this.item) !== 'undefined' && this.item instanceof contractModel){
			return this.item.getValue(name);
		}
		return '';
	}
	
	autosavePostFields(){
		let returnObject = {
			dsmodel: {
				liability_for_recoveries: this.item.liability_for_recoveries,
				liability_for_enforced_recoveries: this.item.liability_for_enforced_recoveries,
				liability_for_enforced_recoveries_data: this.additionalOptions
			}
		};
		return returnObject;
	}

	removeOption(ev, opt) {
		const index = this.additionalOptions.indexOf(opt);
		if (index > -1) {
			this.additionalOptions.splice(index, 1);
		}
		this.triggerAutosave();
	}

	addOption(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "participants", this.optionEditorDialogCtrl],
			templateUrl: 'contracts/option_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				participants: this.participants
			}
		}).then((optionItem) => {
			this.additionalOptions.push(optionItem);
			this.triggerAutosave();
		}, () => {});
	}
	
	optionEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, participants){
		
		$scope.participants = participants;
		$scope.ae_short; 
		$scope.ben_short;
		$scope.ae_long;
		$scope.ben_long;

		$scope.getFinalString = function(){
			let ae_short = $filter('tr')('additional_option_short');
			let ben_short = $filter('tr')('additional_option_short');
			let ae_long = '';
			let ben_long = '';
			if($scope.ae_short){
				ae_short = $scope.ae_short.acronym;
				ae_long = $scope.ae_short.name;
			}
			if($scope.ben_short){
				ben_short = $scope.ben_short.acronym;
				ben_long = $scope.ben_short.name;
			}
			return $filter('tr')('additional_option_tpl')
				.replace(/\{ae_short}/g, ae_short)
				.replace(/\{ae_long}/g,  ae_long)
				.replace(/\{ben_short}/g, ben_short)
				.replace(/\{ben_long}/g,  ben_long);
		};
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function(){
			$mdDialog.hide($scope.getFinalString());
		}; 
	}
	
	triggerAutosave() {
		this.$scope.$broadcast('autosaveFormChanged', {});
	}
	
}


